//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "ContactCard",
	props: {
		contact: Object
	},
	computed: {
		displayName() {
			let str = "";
			if (!this.contact.firstName && !this.contact.lastName) return !!this.contact.product ? this.contact.product : false;
			else {
				if (!!this.contact.firstName) str += this.contact.firstName;
				if (!!this.contact.lastName) str += " " + this.contact.lastName;
			}
			return str;
		},
		phoneAttr() {
			return !!this.contact.phoneNumberLong ? this.contact.phoneNumberLong.toString() : this.contact.phoneNumber;
		},
		phoneDisplay() {
			return !!this.contact.phoneNumber ? this.contact.phoneNumber : this.contact.phoneNumberLong.toString();
		},
	},
	methods: {},
}
